define(
    'providers/dataprovider.persons',[
        "services/config"        
    ],
    function (config) {

        function getPersons() {            
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "get-persons-persons",
                    data: {},
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }
        function getPerson(id) {
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "get-persons-person",
                    data: { id: id },
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function addPerson(rec) {
            var data = {
                displayName: rec.displayName, userName: rec.userName, emailAddress: rec.emailAddress,
                personType: rec.personType, firstName: rec.firstName, lastName: rec.lastName,
                phone: rec.phone, organisationId: rec.organisationId, accessExpiryDate: rec.accessExpiryDate,
                teams: rec.teams, cultureCode: rec.cultureCode, canEditListValues: rec.canEditListValues,
                sendInvitationEmail: 'true'
            };

            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "pos-persons-person",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function updatePerson(rec) {
            var data = {                
                id: rec.id,
                displayName: rec.displayName, userName: rec.userName, emailAddress: rec.emailAddress,
                personType: rec.personType, firstName: rec.firstName, lastName: rec.lastName,
                phone: rec.phone, organisationId: rec.organisationId, accessExpiryDate: rec.accessExpiryDate,
                teams: rec.teams, cultureCode: rec.cultureCode, canEditListValues: rec.canEditListValues
            };
            
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "put-persons-person",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }
        function updatePersonPassword(rec) {
            var data = {
                id: rec.id,
                password: rec.password
            };

            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "put-persons-personpassword",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function deletePerson(id) {
            var data = { id: id};

            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "del-persons-person",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function getPersonTypes() {
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "get-persons-persontypes",
                    data: { },
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }
        function getCultures() {
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "get-persons-cultures",
                    data: {},
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        init();

        return {
            getPersons: getPersons,            
            getPerson: getPerson,
            addPerson: addPerson,
            updatePerson: updatePerson,
            updatePersonPassword: updatePersonPassword,
            deletePerson: deletePerson,
            getPersonTypes: getPersonTypes,
            getCultures: getCultures
        };

        //#region Internal Methods

        function init() {

            //#region Person Maintenance Operations

            amplify.request.define("get-persons-persons", "ajax", {
                url: getUrl("admin/persons"),
                dataType: "json",
                type: "GET"
            });

            amplify.request.define("get-persons-person", "ajax", {
                url: getUrl("admin/persons/{id}"),
                dataType: "json",
                type: "GET"
            });

            amplify.request.define("pos-persons-person", "ajax", {
                url: getUrl("admin/persons"),
                contentType: "application/json",
                dataType: "json",
                type: "POST",
                dataMap: function (data) {return JSON.stringify(data);}
            });

            amplify.request.define("put-persons-person", "ajax", {
                url: getUrl("admin/persons/{id}"),
                contentType: "application/json",
                dataType: "json",
                type: "PUT",
                dataMap: function (data) {return JSON.stringify(data);}
            });

            amplify.request.define("put-persons-personpassword", "ajax", {
                url: getUrl("account/password/set/{id}"),
                contentType: "application/json",
                dataType: "json",
                type: "PUT",
                dataMap: function (data) { return JSON.stringify(data); }
            });

            amplify.request.define("del-persons-person", "ajax", {
                url: getUrl("admin/persons/{id}"),
                dataType: "json",
                type: "DELETE"
            });

            amplify.request.define("get-persons-persontypes", "ajax", {
                url: getUrl("admin/persons/schema/persontypes"),
                dataType: "json",
                type: "GET"
            });

            amplify.request.define("get-persons-cultures", "ajax", {
                url: getUrl("admin/persons/schema/cultures"),
                dataType: "json",
                type: "GET"
            });
            //#endregion
        }

        function getUrl(action) {
            return config.webApiUrl + action;
        }

        //#endregion
    }
);
